import { useContext, useEffect, useRef, useState } from 'react';
import './style.module.css';
import { checkOtp, sendOtp } from '@services/Api';
import { LoaderBtn } from '../loading/Loader';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@context/createContext';
import ToastError from '../toast/ToastError';
import ToastSuccess from '../toast/ToastSuccess';
import { convertNumberPersianToEnglish } from '@helper/functions';

export default function CheckOtpForm({ modalLoginHandler, phone, setLoading, loading, formik, setFlow, setLoginStep }) {
  const [otp, setOtp] = useState(['', '', '', '', '']);
  const [checkOtpBorder, setCheckOtpBorder] = useState(null);
  const inputRefs = useRef([]);
  const [minutes, setMinutes] = useState(2);
  const [second, setSeconds] = useState(0);
  const [failOtpMessage, setFailOtpMessage] = useState('');
  const navigate = useNavigate();

  const { refetch } = useContext(UserContext);

  useEffect(() => {
    const countDown = setInterval(() => {
      if (minutes === 0 && second === 0) {
        clearInterval(countDown);
      } else if (second === 0) {
        setMinutes((prevMinutes) => prevMinutes - 1);
        setSeconds(59);
      } else {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(countDown);
  }, [minutes, second]);

  const handleChange = (element, index) => {
    const sanitizedValue = convertNumberPersianToEnglish(element.value).replace(/[^0-9]/g, '');
    if (sanitizedValue === '') {
      const clearedOtp = [...otp];
      clearedOtp[index] = '';
      setOtp(clearedOtp);
      return;
    }

    const nextDigits = sanitizedValue.split('');
    const newOtp = [...otp];

    nextDigits.forEach((digit, offset) => {
      const targetIndex = index + offset;
      if (targetIndex >= otp.length) return;
      newOtp[targetIndex] = digit;
    });

    setOtp(newOtp);

    // Move to next input if value is entered
    const lastFilledIndex = index + nextDigits.length - 1;
    if (lastFilledIndex < otp.length - 1) {
      const nextIndex = lastFilledIndex + 1;
      inputRefs.current[nextIndex].focus();
    } else if (lastFilledIndex >= otp.length - 1) {
      inputRefs.current[otp.length - 1].blur();
    }

    // Move to previous input if value is deleted
    // if (!value && index > 0) {
    //   inputRefs.current[index - 1].focus();
    // }
  };
  useEffect(() => {
    if (otp[0] != '' && otp[1] != '' && otp[2] != '' && otp[3] != '' && otp[4] != '') {
      CheckOtpHandler();
      inputRefs.current[4].blur();
    }
  }, [otp]);
  const handleKeyDown = (e, index) => {
    if ((e.key === 'Backspace' || e.key === 'Delete') && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    // Focus the first input on component mount
    inputRefs.current[0].focus();
  }, []);

  const CheckOtpHandler = () => {
    setLoading(true);
    checkOtp(phone[0] == '0' ? phone : '0' + phone, otp.join(''))
      .then((res) => {
        if (res.status == 'success') {
          setCheckOtpBorder(true);
          res.hasAccount == false ? setFlow((prev) => ({ prev, step: 2 })) : refetch();
          modalLoginHandler();
          formik.resetForm();
          ToastSuccess({ content: 'با موفقیت وارد حساب کاربری شدید' });
        } else {
          setLoading(false);
          setFailOtpMessage(res.message);
          setOtp(['', '', '', '', '']);
          setCheckOtpBorder(false);
          setTimeout(() => {
            setCheckOtpBorder(null);
            inputRefs.current[0].focus();
          }, 1500);
        }
      })
      .catch((e) => {
        ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید.' });
        setLoading(false);
      })
      .finally((e) => {
        // setLoading(false);
      });
  };
  const resendOtp = () => {
    sendOtp(phone)
      .then((res) => {
        if (res.status == 'success') {
          setLoginStep(2);
          ToastSuccess({ content: 'کد یکبار مصرف برای شما ارسال شد' });
        } else {
          ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید.' });
        }
      })
      .catch((e) => {
        ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید.' });
      })
      .finally((e) => {
        setLoading(false);
      });
    setMinutes(2);
    setSeconds(0);
  };
  return (
    <div className="w-full max-w-[600px] h-fit bg-white dark:bg-blackFont-900 z-[110] md:rounded-2xl rounded-none relative overflow-hidden">
      <div className="flex flex-col gap-12 items-center w-full relative py-12 px-2 md:px-20">
        {/* title */}
        <div className="flex flex-col items-center gap-2 z-10">
          <span className="text-[22px] font-bold text-text-hard dark:text-white">کد تایید را وارد کنید</span>
          <span className="text-[17px] font-[400] text-blackFont-600 dark:text-blackFont-300">
            کد ۵ رقمی به شماره <span className="font-medium">{phone}</span>
            ارسال شد
          </span>
        </div>
        {/* input */}
        <div className="flex flex-col w-full gap-3 z-10">
          <button
            onClick={() => {
              setLoginStep(1);
              setLoading(false);
            }}
            disabled={loading}
            dir="rtl"
            className="hover:bg-primary/10 transition-all py-1 px-2 rounded-xl text-primary text-[14px] cursor-pointer flex items-center gap-2 w-fit"
          >
            <img className="w-4" src="/svg/edit-2.svg" alt="edit" />
            <span>ویرایش شماره موبایل</span>
          </button>
          <div dir="ltr" className="flex items-center justify-between gap-2 md:gap-5 w-full relative">
            {otp.map((data, index) => (
              <label
                key={index}
                htmlFor={`otp-${index}`}
                className={`rounded-lg border-[1px] bg-white dark:bg-blackFont-800 ${
                  checkOtpBorder
                    ? 'border-success'
                    : checkOtpBorder === false
                      ? 'border-error'
                      : 'border-light-grey dark:border-blackFont-700'
                } w-full h-[50px] has-[:focus]:border-blackFont-900 dark:has-[:focus]:border-blackFont-400 overflow-hidden transition-all p-1 flex items-center justify-center`}
              >
                <input
                  id={`otp-${index}`}
                  name={`otp-${index}`}
                  dir="ltr"
                  maxLength={1}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onFocus={(e) => e.target.select()}
                  ref={(el) => (inputRefs.current[index] = el)}
                  className="p-2 text-center w-full h-full bg-transparent text-[18px] text-text-hard dark:text-white placeholder:text-text-normal/70 dark:placeholder:text-blackFont-400"
                  type="text"
                  inputMode="numeric"
                />
              </label>
            ))}
            <span
              className={`text-[12px] text-error absolute -bottom-[22px] right-0 transition-all whitespace-nowrap w-full ${
                checkOtpBorder === false ? 'visible opacity-100' : 'invisible opacity-0'
              }`}
            >
              {failOtpMessage.split('(')[0]}
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3 w-full z-10">
          <div className="flex items-center justify-center w-full">
            {second == 0 && minutes == 0 ? (
              <span
                onClick={resendOtp}
                className="hover:bg-primary/10 transition-all py-1 px-2 rounded-xl text-primary text-[14px] cursor-pointer"
              >
                ارسال مجدد کد پیامکی
              </span>
            ) : (
              <span className="text-[13px] text-blackFont-500 dark:text-blackFont-400">
                0{minutes}:{second} تا درخواست مجدد کد
              </span>
            )}
          </div>
          <button
            onClick={CheckOtpHandler}
            disabled={loading}
            className="bg-primary disabled:cursor-not-allowed disabled:bg-blackFont-300 w-full h-[48px] flex items-center justify-center text-white rounded-lg"
          >
            {loading ? <LoaderBtn /> : 'تایید و ادامه'}
          </button>
        </div>
      </div>
    </div>
  );
}
